import React, {useEffect, useState} from "react";
import * as Scroll from "react-scroll";

export const BackToTopButton = () => {
    const [isCrossedOver, setIsCrossedOver] = useState(false);

    const scrollToTop = () => Scroll.animateScroll.scrollToTop();

    const onScroll = () => {
        const position = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
        // NOTE: TopページニュースセクションあたりでBackToButtonを表示する仕様のため、おおよそのpxをベタ書き
        if (position >= 1080) {
            setIsCrossedOver(true);
        } else {
            setIsCrossedOver(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", onScroll);
        return () => document.removeEventListener("scroll", onScroll);
    });

        return (
            <div className={`btn_getop_link display_pc vertical ${isCrossedOver ? 'appear' : 'disappear'}`} onClick={scrollToTop}><a /></div>
        )
}
